import React from "react";
import { MaterialUiSelect } from "../Select";
import { COORDINATE_FORMATS } from "hooks/useGpsCoordinates";
import { IColumn, MetaInfo } from "./types";

interface ColumnsDropdownProps {
  rowIndex: number;
  values: any;
  handleBlur: (e: any) => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  otherQueryFilterErrors: any;
  otherQueryFilterTouched: any;
  availableColumns: IColumn[];
}

const ColumnsDropdown: React.FC<ColumnsDropdownProps> = ({
  rowIndex,
  values,
  handleBlur,
  setFieldValue,
  otherQueryFilterErrors,
  otherQueryFilterTouched,
  availableColumns,
}) => {
  return (
    <MaterialUiSelect
      width={"100%"}
      options={availableColumns}
      labelKey="title"
      valueKey="column"
      error={otherQueryFilterErrors?.column}
      initialValue={values?.otherQueryFilter[rowIndex]?.column}
      handleChange={(value: any) => {
        const { metaInfo, column, type, inputType } = value;

        const updatedMetaInfo: MetaInfo = {
          choicesByUrl: metaInfo.choicesByUrl || null,
          choices: metaInfo.choicesByUrl ? null : metaInfo.choices,
        };

        const defaultValue =
          type === "gpsCoordinates"
            ? {
                coordinates_format: COORDINATE_FORMATS.DECIMAL_DEGREES,
                latitude: "",
                longitude: "",
              }
            : null;

        setFieldValue(`otherQueryFilter[${rowIndex}].column`, column);
        setFieldValue(`otherQueryFilter[${rowIndex}].value`, defaultValue);
        setFieldValue(`otherQueryFilter[${rowIndex}].type`, type);
        setFieldValue(`otherQueryFilter[${rowIndex}].inputType`, inputType);
        setFieldValue(`otherQueryFilter[${rowIndex}].condition`, null);
        setFieldValue(
          `otherQueryFilter[${rowIndex}].metaInfo`,
          updatedMetaInfo
        );
      }}
      inputStyles={{ border: "none" }}
      className="border-none capitalize"
    />
  );
};

export default ColumnsDropdown;
